export default __webpack_public_path__ + "9bdb99330ca56c7d8ac87a588cc915ae.png";